<template>
  <div>
    <div class="columns">
      <div class="column is-2">
        <b-icon icon="bed"></b-icon>
      </div>
      <div class="column is-10">
        <h4 class="is-size-6 has-text-weight-bold"> {{ room.hotelName}}</h4>
        <h4 class="is-size-7"> {{ room.chainName }}</h4>
<!--         {{room}}-->
        <p class="is-size-6 has-text-grey-light">  {{ room.startDate | formatDate }} - {{ room.endDate | formatDate }} </p>
        <div class="is-size-7">{{ room.description.bedMessage}}</div>
        <OutOfPolicyTag v-if="room.travelPolicy" class="" :travelPolicy="room.travelPolicy"></OutOfPolicyTag>
        <a v-if="!display_full" @click="display_full = !display_full" class="gant-text is-size-7">Show details</a>
        <a v-else @click="display_full = !display_full" class="is-size-7">Hide details</a><br />
      </div>
    </div>
    <div v-if="display_full" class="columns is-vcentered mt-2">
      <div class="column is-5">
        <img width="200" :src="room.image">
      </div>
      <div class="column is-vcentered">
        <div>
          <span class="is-size-6 has-text-grey-light"> {{ room.hotelName}} </span><br />
          <div class="is-size-7 has-text-grey-light capitalize" style="font-size: 12px;">{{ room.textDescription}}... </div>
          <div class="is-size-7 has-text-grey-light capitalize" style="font-size: 12px;">
            <span v-if="isWebBedsHotel(room.infoSource)" class="amenity-tag"><i class="fa fa-ban mr-1"></i>No Loyalty Points</span>
          </div>
          <span style="font-size: 12px; padding-top: 5px; margin-right: -5px;"> <a @click="goToMaps(room.geocode.Latitude , room.geocode.Longitude)"> {{ room.address }}</a> </span> <b-icon icon="map-marker"></b-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import OutOfPolicyTag from '../Tags/OutOfPolicyTag.vue';
  import GMap from '../GMap/GMap.vue';

  export default {
    name: 'SmallHotelItinerary',
    components: {
        OutOfPolicyTag,
      },
    props: {
        room: Object,
      },
    data: function () {
      return {
        display_full: false,
      }
    },
    methods: {
      goToMaps(lat, long) {
        // console.log('tried')
        var details = {
            parent: this,
            component: GMap,
            props: {
              "lat": lat,
              "long": long,
              "width": '700',
              "height": '600',
              'carOrHotel': 'bed'
          },
            hasModalCard: true,
            trapFocus: true,
            width: 700
        }
          this.$buefy.modal.open(details)
      },
      isWebBedsHotel(infoSource) {
        return infoSource == "SJ"
      }
    },
  }
</script>

<style scoped>
</style>
